import {Sortable} from "./sortable.js";
import JSX from "../../helpers/react.js";
import {slimCustom} from "../../helpers/slim-select.jquery.js";


function onLoad() {
    const $editForm = $(".edit-form");
    const dubbingsEl = $<HTMLSelectElement>('select[name=dubbings]'),
        playersEl = $<HTMLSelectElement>('select[name=players]');

    new SlimSelect(slimCustom.apply(playersEl[0], [function (v) {
        if (!v.startsWith('Плеер')) return false;
        return {
            text: v + '(0 эп.)',
            value: v
        }
    }]));
    new SlimSelect(slimCustom.apply(dubbingsEl[0])); //

    function newVideo() {
        const maxIndex = Math.max(...Array.from($('.video-edit').map(function (index, el) {
                return getElIndex($(el))! as number;
            })))! + 1,
            videosInserted = $(".video-edit[data-id='-1']").length;
        const wl = $(<li className="video-edit" data-id="-1">
<input className="small-field bordered" name={`insert_video[${videosInserted}][_name]`} type="text" value='' placeholder="№ эп."/>
<input name={`insert_video[${videosInserted}][_frame]`} type="text" value="" className="bordered"/>
<input name={`insert_video[${videosInserted}][_index]`} value={maxIndex} hidden="hidden" />
<input name={`insert_video[${videosInserted}][_dub]`} hidden="hidden" />
<input name={`insert_video[${videosInserted}][_player]`} hidden="hidden" />
<div className="buttons">
    <div className="delete-button">
        <i className="far fa-trash"></i>
    </div>
</div>
                </li>).attr('data-player', playersEl.val()! as string).attr('data-dub', dubbingsEl.val()! as string),
            lastEp = parseInt($('.edit-anime .episodes-container .video-edit').last().find('input[name*=_name]').val()! as string) + 1;
        if (!Number.isNaN(lastEp)) wl.find('input[name*=_name]').val(lastEp + '');
        wl.find('input[name*=_dub]').val(dubbingsEl.val()!);
        wl.find('input[name*=_player]').val(playersEl.val()!);
        wl.appendTo('.edit-anime .episodes-container');
        onPlayersChange();
    }

    function getElIndex(el: JQuery): number {
        return el.find('input[name*=_index]').val()! as number;
    }

    function onPlayersChange() {
        $('#video-content .episodes-container .video-edit').detach().appendTo('#video-content .episodes-container-hidden')
        const currentDub = dubbingsEl.val(),
            currentPlayer = playersEl.val(),
            $items = $('.video-edit').filter(function () {
                const $th = $(this);
                return $th.data('dub') === currentDub && $th.data('player') === currentPlayer;
            });
        $items.detach().appendTo('#video-content .episodes-container');
        Sortable.create($('#video-content .episodes-container')[0], {
            ghostClass: 'transparent',
            onEnd(e){
                onVideoMove(e);
            }

        });
    }
    function onVideoMove(e:Sortable.SortableEvent){
        const fromIndex = e.oldIndex!,
            toIndex = e.newIndex!,
            children = $("#video-content .episodes-container").children();
        if (toIndex === fromIndex) return;
        const movedIndex = getElIndex(children.eq(toIndex));
        if(toIndex < fromIndex){
            for(let i=toIndex;i<fromIndex;i++)
                updateElIndex(children.eq(i), getElIndex(children.eq(i+1)));
            updateElIndex(children.eq(fromIndex), movedIndex)
        }
        else{
            const toIndexU = getElIndex(children.eq(toIndex));
            for(let i=toIndex;i>fromIndex;i--)
                updateElIndex(children.eq(i), getElIndex(children.eq(i-1)));
            updateElIndex(children.eq(fromIndex),toIndexU )

        }
    }
    function updateElIndex(el: JQuery, newIndex: number){
        return el.find('input[name*=_index]').val(newIndex);
    }
    function onDubbingChange(){
        playersEl.text('');
        const currentDub = dubbingsEl.val(),
            $items = $('.video-edit').filter(function(){return $(this).data('dub') === currentDub;}),
            players: any = {};
        $items.each(function(){
            const $this = $(this);
            const player = $this.data('player');
            if(player in players) players[player]++;
            else players[player] = 1;
        });
        for(let player in players){
            $("<option></option>").text(`${player}(${players[player]} эп.)`).val(player ).appendTo(playersEl);
        }
        onPlayersChange();
    }
    onDubbingChange();
    $editForm.on('click','.add-video-button', newVideo);
    dubbingsEl.on('change', onDubbingChange);
    playersEl.on('change', onPlayersChange);

}

document.addEventListener('oneditformload', onLoad);

$('html').on('click',".edit-form .delete-button", '.delete-button', function(){
        $(this).closest('.video-edit,.item-sorting').remove();
    })
    .on('input', '.edit-form .cover-image', function(){
        if (FileReader && this.files && this.files.length) {
            const fr = new FileReader();
            fr.onload = function () {
                $<HTMLImageElement>('.edit-form .poster-block img')[0].src = fr.result! as string;
            };
            fr.readAsDataURL(this.files[0]);
        }
    })
    .on('click', '.edit-form .poster-block', function(){
       $('.edit-form .cover-image').trigger('click');
    })
    .on('submit','.edit-form', function (){
        $('select[name=dubbings],select[name=players]').prop('disabled', "disabled");
    // playersEl.prop('disabled', "disabled");
    // return true;
});